import { FormattedMessage } from "react-intl";
import { useContractEndNoteHistory } from "../../api/getContractEndNoteHistory";
import ContractFieldHistoryDialog from "../ContractFieldHistoryDialog/ContractFieldHistoryDialog";

type TEndNoteHistoryDialogProps = {
  open: boolean;
  contractId: string;
  contractName?: string;
  onClose: () => void;
};

const EndNoteHistoryDialog = ({
  open,
  contractId,
  contractName,
  onClose,
}: TEndNoteHistoryDialogProps) => {
  const historyQuery = useContractEndNoteHistory({
    contractId,
    config: { enabled: open },
  });

  return (
    <ContractFieldHistoryDialog
      open={open}
      dialogId="end-note-history-dialog"
      contractName={contractName}
      historyQuery={historyQuery}
      onClose={onClose}
      title={
        <FormattedMessage
          id="EndNote.Histórico de la nota"
          defaultMessage="Histórico de la nota"
        />
      }
      emptyText={
        <FormattedMessage
          id="EndNote.No hay cambios registrados en la nota"
          defaultMessage="No hay cambios registrados en la nota"
        />
      }
      errorText={
        <FormattedMessage
          id="EndNote.No se ha podido cargar el histórico de la nota"
          defaultMessage="No se ha podido cargar el histórico de la nota"
        />
      }
    />
  );
};

export default EndNoteHistoryDialog;
